
export default `
query customAttributeMetadata($attribute_code: String, $entity_type: String){
  customAttributeMetadata(
    attributes: [
      {
        attribute_code: $attribute_code
        entity_type: $entity_type
      }
    ]
  ) {
    items {
      attribute_code
      attribute_type
      entity_type
      input_type
      attribute_options {
       value
       label
     }
    }
  }
}

`;